export default {"src":"/_next/static/media/v.bd4b4ef4.svg","height":4000,"width":5000,"blurWidth":0,"blurHeight":0};